module.exports = __webpack_public_path__ + "static/media/after_dino.a0b33033.mp3";